/*
 * Words that change with the company's trade, kept in one place.
 */
import type { Trade } from "./core.js";

/** Workers are cleaners only at a cleaning company; everywhere else they are the crew. */
export function workerWord(trade: Trade, plural = true): string {
  if (trade === "cleaning") return plural ? "cleaners" : "cleaner";
  return "crew";
}

/** The trade's word for the work, for a job with no title or service ("Cleaning"), as the old Steward said it. */
export function serviceWord(trade: Trade): string {
  switch (trade) {
    case "cleaning":
      return "Cleaning";
    case "lawn":
      return "Lawn service";
    case "washers":
      return "Exterior washing";
    case "agency":
      return "Marketing";
    default:
      return "Service";
  }
}

/** "Kenia R." for lists, since two people can share a first name. */
export function shortName(firstName: string, lastName: string | null | undefined): string {
  const initial = lastName?.trim().charAt(0).toUpperCase();
  return initial ? `${firstName.trim()} ${initial}.` : firstName.trim();
}
